import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {IconBox, Ic} from './IconBox';

export function BaseCoverageRow({icon, title, price, description, mandatory, removed, onToggle, last}) {
  const theme = useTheme();
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      padding: '18px 4px',
      borderBottom: last ? 'none' : `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 14, flex: '1 1 320px', minWidth: 260, justifyContent: 'flex-start', textAlign: 'right',
        opacity: removed ? 0.55 : 1,
        transition: 'opacity 200ms ease-out',
      }}>
        <div style={{order: 2}}>
          <div style={{
            fontWeight: theme.typography.fontWeightBlack,
            fontSize: theme.typography.pxToRem(16),
            color: theme.palette.secondary.main,
            lineHeight: 1.35,
          }}>
            {title}
            {price && <span style={{fontWeight: theme.typography.fontWeightBlack, color: theme.palette.secondary.main}}>
              <FormattedMessage id='coverage.averageCost' values={{price}}/>
            </span>}
          </div>
          {description && <div style={{
            fontSize: theme.typography.pxToRem(13), color: theme.palette.text.secondary, lineHeight: 1.5, marginTop: 3,
          }}>{description}</div>}
        </div>
        <span style={{order: 1}}><IconBox icon={icon} /></span>
      </div>
      <div style={{flex: 'none', display: 'flex', alignItems: 'center', gap: 10}}>
        {mandatory ? (
          <span style={{fontSize: theme.typography.pxToRem(13), fontWeight: theme.typography.fontWeightSemiBold, color: theme.palette.text.disabled}}>
            <FormattedMessage id='coverage.cannotRemove'/>
          </span>
        ) : removed ? (
          <button
            type='button'
            onClick={onToggle}
            style={{
              height: 40,
              padding: '0 22px',
              cursor: 'pointer',
              borderRadius: 'var(--wobi-v2-radius-full, 9999px)',
              border: `1.5px solid ${theme.palette.primary.main}`,
              background: theme.palette.primary.lighter,
              color: theme.palette.primary.dark,
              fontWeight: theme.typography.fontWeightBold,
              fontSize: theme.typography.pxToRem(14.5),
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              transition: 'transform 160ms ease-out',
            }}
          >
            <Ic name='check' size={16} /> <FormattedMessage id='coverage.addBack'/>
          </button>
        ) : (
          <button
            type='button'
            onClick={onToggle}
            style={{
              height: 40,
              padding: '0 20px',
              cursor: 'pointer',
              borderRadius: 'var(--wobi-v2-radius-full, 9999px)',
              border: `1.5px solid ${theme.palette.divider}`,
              background: theme.palette.background.paper,
              color: theme.palette.text.secondary,
              fontWeight: theme.typography.fontWeightBold,
              fontSize: theme.typography.pxToRem(14.5),
              transition: 'transform 160ms ease-out',
            }}
          >
            <FormattedMessage id='step1.tab4.remove'/>
          </button>
        )}
      </div>
    </div>
  );
}
